import { createFileRoute } from '@tanstack/react-router'

import { InjectableParamsDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/injectable-params-documentation-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/documentation/injectable-params')({
  component: () => (
    <PermissionChecker requiredPermissions={['documentation.read']}>
      <InjectableParamsDocumentationPage audience="backoffice" />
    </PermissionChecker>
  ),
})
